import FilterComplex from './filterComplex';

export default FilterComplex;
